import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';

import {ToastsManager} from 'ng6-toastr';
import {HttpParams} from '@angular/common/http';
import {RequestsService} from '../services/requests.service';

@Component({
  selector: 'app-forget',
  templateUrl: './forget.component.html',
  styleUrls: []
})
export class ForgetComponent implements OnInit {

  /// Settings 
  login_heading: string;
  login_text: string;

  /// Forget 
  email: string;

  resetBtnDisabled: boolean = false;


  constructor(private router: Router, public toastr: ToastsManager, vcr: ViewContainerRef, private requestsService: RequestsService) {
    this.toastr.setRootViewContainerRef(vcr);
  }

  ngOnInit() {
    return this.requestsService.getSettingsRequest('auth/settings').subscribe((response: Response) => {
      this.login_heading = response['login_heading'];
      this.login_text = response['login_text'];
    });
  }


  onSubmit() {
    this.resetBtnDisabled = true;
    let body = new HttpParams();
    body = body.set('email', this.email);

    return this.requestsService.postRequestauthToken('auth/forget_password', body).subscribe((response: Response) => {

      if (response['result_type'] == 'Success') {
        this.toastr.success(response['message'], response['result_type']);
      } else {
        window.localStorage.removeItem(btoa('access_token'));
        window.localStorage.removeItem(btoa('expire_in'));
        this.toastr.error(response['message'], response['result_type']);
      }
      this.resetBtnDisabled = false;

    });

  }

}

@Component({
  selector: 'app-reset',
  templateUrl: './reset.component.html',
  styleUrls: []
})
export class ResetComponent implements OnInit {

  // Settings
  login_heading: string;
  login_text: string;

  // RESET
  password: string;
  token: string;
    cpassword: any;


  constructor(private activatedRoute: ActivatedRoute, private router: Router, public toastr: ToastsManager, vcr: ViewContainerRef, private requestsService: RequestsService) {
    this.toastr.setRootViewContainerRef(vcr);
    this.token = this.activatedRoute.snapshot.params.token;
  }

  ngOnInit() {
     this.requestsService.getSettingsRequest('auth/settings').subscribe((response: Response) => {
            this.login_heading = response['login_heading'];
            this.login_text = response['login_text'];

    });
  }

  onSubmit() {
    let body = new HttpParams();
    body = body.set('password', this.password);
    body = body.set('token', this.token);

    return this.requestsService.postRequestauthToken('/auth/reset', body).subscribe((response: Response) => {
      if (response['result_type'] == 'Success') {
        this.toastr.success(response['message'], response['result_type']);
        this.router.navigate(['/login']);
      } else {
        this.toastr.error(response['message'], response['result_type']);
      }
    });

  }
}
